import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import NotFoundPage from './pages/not-found';

// Create a new router instance
export const router = createRouter({
	routeTree: routeTree,
	defaultNotFoundComponent: NotFoundPage,
	defaultPreload: 'intent',
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}
}
